import React from 'react'
import { Tooltip } from '@mui/material'
import { useSnapshot } from 'valtio'
import { faSquareRootVariable } from '@fortawesome/pro-solid-svg-icons/faSquareRootVariable'
import { StyledIconButton, StyledIcon } from '../styles'
import { useModal } from '@app/helpers'
import { CurrentUserAssessmentState } from '@app/storage'
import { FormulaSheetDialog, isFormulaSheetProgram, useIsFormulaSheetEnabled } from '@app/components/common/FormulaSheet'

const FORMULA_SHEET_LABEL = 'Formula Sheet'

const FormulaSheetTool: React.FC = () => {
  const { open, onOpen, onClose } = useModal(false)
  const { program } = useSnapshot(CurrentUserAssessmentState)
  const isFormulaSheetEnabled = useIsFormulaSheetEnabled()

  if (!isFormulaSheetEnabled || !isFormulaSheetProgram(program)) return null

  return (
    <>
      <Tooltip title={FORMULA_SHEET_LABEL}>
        <StyledIconButton
          aria-label={FORMULA_SHEET_LABEL}
          aria-pressed={open}
          onClick={open ? onClose : onOpen}
          className={open ? 'active' : ''}
          data-automation-id='formula-sheet-button'
        >
          <StyledIcon icon={faSquareRootVariable} />
        </StyledIconButton>
      </Tooltip>

      <FormulaSheetDialog open={open} onClose={onClose} />
    </>
  )
}

export default FormulaSheetTool
